import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { message, Spin, Radio } from "antd";
import Button from "../../components/Button";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";
import $ from 'jquery'

const Add = () => {
  // state list
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [featureType, setFeatureType] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    Bridge.audit_logs.view_add_consortia_requests();
    if ($(window).width() < 600) {
      console.log("window::", window);
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
  }, []);
  // add new user
  const addUser = () => {
    if (!title) {
      message.warning("Please enter title.");
      return;
    } else if (!description) {
      message.warning("Please enter description.");
      return;
    } else if (!featureType) {
      message.warning("Please select feature type.");
      return;
    }
    let params = {
      title: title,
      description: description,
      feature_type: featureType,
      user_id: localStorage.getItem("consortia_user_id"),
    };
    setLoading(true);
    Bridge.feature_roadmap
      .save(params)
      .then((result) => {
        if (result.status === 1) {
          message.success(result.message, 5);
          window.location.assign("/consortia-requests");
        } else {
          message.error(result.message, 5);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-lg-10 ml-auto main-section add-user top-space">
          <a href="#" onClick={() => window.history.back()} className="go-back">
            <i className="fas fa-chevron-left"></i>
          </a>
          <div className="wrapper clearfix" style={{ paddingTop: 0 }}>
            <div className="multisteps-form add-admin-user-form">
              <div className="row">
                <div className="col-12 col-lg-12 m-auto">
                  <Spin spinning={loading}>
                    <div
                      className="multisteps-form__panel js-active addStudentForm"
                      data-animation="slideVert"
                    >
                      <div className="inner pb-100">
                        <div className="wizard-content-form">
                          <div
                            className="wizard-form-field"
                            style={{ margin: "53px 0 0" }}
                          >
                            <h3 className="user-profile-heading">
                              {Strings.addConsortiaRequest}
                            </h3>
                            <br />
                            <div className="row">
                              <div className="col-lg-7">
                                <label className="label-name">
                                  Title <span className="text-danger">*</span>
                                </label>
                                <div className="wizard-form-input position-relative form-group has-float-label">
                                  <input
                                    type="text"
                                    name="title"
                                    className="form-control"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                  />
                                </div>
                                <label className="label-name">
                                  Description{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="wizard-form-input position-relative form-group has-float-label">
                                  <textarea
                                    id="txtid"
                                    name="description"
                                    value={description}
                                    onChange={(e) =>
                                      setDescription(e.target.value)
                                    }
                                    rows={2}
                                    cols={50}
                                    style={{
                                      width: "100%",
                                      padding: 20,
                                      background: "#ddeef9",
                                      fontSize: 18,
                                      border: "none",
                                    }}
                                  ></textarea>
                                </div>
                                <label className="label-name mt-4">
                                  Type <span className="text-danger">*</span>
                                </label>
                                <div className="wizard-form-input position-relative form-group has-float-label">
                                  <select
                                    className="form-control"
                                    name="featureType"
                                    onChange={(e) =>
                                      setFeatureType(e.target.value)
                                    }
                                    value={featureType}
                                  >
                                    <option value="">Select</option>
                                    <option value="Bug">Bug</option>
                                    <option value="Feature">Feature</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Button
                          to="#"
                          isClickable={true}
                          click={addUser}
                          style={{ marginLeft: 4, marginTop: 20 }}
                        >
                          <i className="fa fa-arrow-right"></i>&nbsp; Submit
                        </Button>
                      </div>
                    </div>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Add;
